import React, { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";

import RegisterAuditory from "@auditory/component/RegisterAuditory";
import { AUDITORY_MODEL, DATA_MODEL } from "../models/model";
import SectionPersonalData from "../components/SectionPersonalData";
import { ModalAddBeneficiaries } from "@/components/organisms/ModalAddBeneficiaries";
import { showModalAddBeneficiaries as showModalAddBeneficiariesAction } from "@/redux/actions/beneficiaries";
import helpers from "@/utils/helpers";
import { PlansProvider } from "../../step-plans/context/PlansContext";
import { getProductOptions } from '@/utils/product'
import useScrollToPosition from '@/hooks/useScrollToPosition'

const StepData = () => {
  useScrollToPosition();
  const { showModalAddBeneficiaries } = useSelector(
    (state) => state.beneficiaries
  );

  const { userData } = useSelector((state) => state.vida);
  const isEmbedded = userData?.indPrevPageApp;
  const { digitalDataProductName } = getProductOptions();

  const dispatch = useDispatch();

  const callAnalyticsAction = () => {
    helpers.getTagAction(
      digitalDataProductName,
      "Dirección",
      "click",
      "Ver detalle",
      "trackAction"
    );
  };

  useEffect(() => {
    return () => {
      dispatch(showModalAddBeneficiariesAction(false));
    };
  }, []);

  useEffect(() => {
    if (isEmbedded) {
      return helpers.sendMessageToApp(
        showModalAddBeneficiaries
          ? "EMBEDDED-APP-HIDE-TOPBAR"
          : "EMBEDDED-APP-SHOW-TOPBAR"
      );
    }
  }, [showModalAddBeneficiaries, isEmbedded]);

  return (
    <PlansProvider>
      <div className="rbr-rimac-grid">
        <RegisterAuditory authoring={AUDITORY_MODEL} />
        <SectionPersonalData {...DATA_MODEL} analyticsDetailAction={callAnalyticsAction} />
        {showModalAddBeneficiaries && (
          <ModalAddBeneficiaries
            isOpen={showModalAddBeneficiaries}
            nextStep="/comprar/seguro-vida-endoso-con-devolucion/pago"
            stepFinish={4}
            product={digitalDataProductName}
          />
        )}
      </div>
    </PlansProvider>
  );
};

export default StepData;
